export const REQUEST_INITIAL_SERVICE_LOADING =
  "REQUEST_INITIAL_SERVICE_LOADING";
export const REQUEST_INITIAL_SERVICE_SUCCESS =
  "REQUEST_INITIAL_SERVICE_SUCCESS";
export const REQUEST_INITIAL_SERVICE_ERROR = "REQUEST_INITIAL_SERVICE_ERROR";
